import { render, staticRenderFns } from "./SearchVideoTagsFilter.vue?vue&type=template&id=2fb769b2&scoped=true&"
import script from "./SearchVideoTagsFilter.vue?vue&type=script&lang=js&"
export * from "./SearchVideoTagsFilter.vue?vue&type=script&lang=js&"
import style0 from "./SearchVideoTagsFilter.vue?vue&type=style&index=0&id=2fb769b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb769b2",
  null
  
)

export default component.exports